import React from 'react'
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Link } from "react-router-dom"
import { MDBDataTable } from "mdbreact"
import {
  Row, Col, CardBody, Card, Container, Button,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const Customers = props => {
  const data = {
    columns: [
      {
        label: "Customer Name",
        field: "CustomerName",
        sort: "asc",
        attributes: { width: "20%" },
      },
      {
        label: "Mobile Number",
        field: "MobileNumber",
        sort: "asc",
        attributes: { width: "15%" },

      },
      {
        label: "Email",
        field: "Email",
        sort: "asc",
        attributes: { width: "15%" },

      },
      {
        label: "Number of Order",
        field: "NumberofOrder",
        sort: "asc",
        attributes: { width: "12%"},
      },
      {
        label: "Registration Date",
        field: "RegistrationDate",
        sort: "asc",
        attributes: { width: "12%" },

      },
      {
        label: "Actions",
        field: "Actions",
        sort: "asc",
        attributes: { width: "12%" },
      },
    ],
    rows: [
      {
        CustomerName: "Yana Suthar",
        MobileNumber: "9638869115",
        Email: "yanasuthar34@gmail.com",
        NumberofOrder: "61",
        RegistrationDate: "16/08/2022",
        Actions:
          (
            <>
              <Link
                to={{

                  pathname: "/customer-detail",
                }} >

                <Button
                  className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                  style={{ width: "25px", height: "25px", padding: "0px" }}
                  title="View"
                  onClick={() => {

                  }}
                >
                  <i className="fas fa-eye"></i>
                </Button>
              </Link>
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{ width: "25px", height: "25px", padding: "0px" }}
                title="Delete"
                onClick={() => {

                }}
              >
                <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
              </Button>{" "}
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{
                  width: "25px",
                  height: "25px",
                  padding: "0px",
                }}
                title="Active / Inactive"
                onClick={() => { }

                }
              >
                <i className="fas fa-bullseye" style={{ color: "#38e038" }}></i>

              </Button>
            </>
          ),
      },
    ]
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Customer")} | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Customer List ")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    responsive
                    bordered
                    noBottomColumns
                    theadColor={"btn-primary"}
                    data={data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
Customers.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(Customers))

